import script from "./TableData.vue?vue&type=script&setup=true&lang=js"
export * from "./TableData.vue?vue&type=script&setup=true&lang=js"

import "./TableData.vue?vue&type=style&index=0&id=6f451d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f451d3c"]])

export default __exports__